<!--Form-->
<form [formGroup]="form">
	<div class="card">
		<div class="card-body">
			<div class="alert alert-warning hide-large-view" role="alert">
				Bulk upload is recommended to use from desktops!
			  </div>
			<h5 class="card-title">{{title || 'File selection'}}</h5>
			<a class="text-secondary d-inline-block mb-3" target="_blank" *ngIf="templateFileUrl" href="{{templateFileUrl}}"><i class='bx bx-download'></i>&nbsp;Download sample template</a>
			<div class="row">
				<div class="col-6">
					<div class="form-group">
						<label for="fileDropRef" [ngClass]="{'disabled': isUploading}" class="btn btn-light btn-sm">
							{{isUploading ? 'Uploading ...': properties?.label }}</label>
						<input style="visibility:hidden;" [disabled]="isUploading" type="file" #fileDropRef id="fileDropRef"
							(change)="handleFileInput($event.target.files)">
						<div *ngIf="properties.filePreview && parseResponse?.fileName" class="list mt-2">
							<a href="javascript:;">{{parseResponse?.fileName}}</a>
						</div>
						<small *ngIf="isSubmitted && !parseResponse?.fileName || errorMessage" class="text-danger">
							<div>{{errorMessage || 'File selection is required'}}</div>
						</small>
					</div>
					<div class="form-group" *ngIf="parseResponse?.parsedData?.length > 1">
						<label>Select sheet</label>
						<select class="form-control" (change)="onSheetSelect($event)" formControlName="sheet"
							[ngClass]="{ 'is-invalid': isSubmitted && f.sheet.errors }">
							<option value=""></option>
							<option *ngFor="let sheet of parseResponse.parsedData" value="{{sheet.sheetName}}">{{sheet.sheetName}}</option>
						</select>
						<div *ngIf="isSubmitted && f.sheet.errors" class="invalid-feedback">
							<div *ngIf="f.sheet.errors.required">Sheet is required</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card-footer">
			<am-button [text]="submitButtonText" (click)="onSubmit()" [isLoading]="isUploading"></am-button>
			<a href="javascript:;" (click)="cancel()" class="btn btn-light ml-3">{{cancelButtonText}}</a>
		</div>
	</div>
</form>